import { IVehicleShopVehicle } from '~/shared';
import { createSlice } from '../wrappers';

const initialState = {
	selectedIndex: 0,
	maxIndex: 0,
	selectedVehicle: null as null | IVehicleShopVehicle,
};

const vehicleSelectionSlice = createSlice({
	name: 'vehicleSelection',
	initialState,
	reducers: {
		setSelectedIndex: (state, action) => {
			state.selectedIndex = action.payload;
		},
		setSelectedIndexPrev: (state) => {
			const index = state.selectedIndex;
			state.selectedIndex = index > 0 ? index - 1 : index;
		},
		setSelectedIndexNext: (state) => {
			const index = state.selectedIndex;
			const maxIndex = state.maxIndex;
			state.selectedIndex = index < maxIndex ? index + 1 : index;
		},
		setMaxIndex: (state, action) => {
			state.maxIndex = action.payload;
		},
		setSelectedVehicle: (state, action) => {
			state.selectedVehicle = action.payload;
		},
	},
});

export const {
	setSelectedIndex,
	setSelectedIndexPrev,
	setSelectedIndexNext,
	setMaxIndex,
	setSelectedVehicle,
} = vehicleSelectionSlice.actions;

export default vehicleSelectionSlice.reducer;
